export default {
  showChangelog: 'Show all release notes',
};
